import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Login from './pages/Login';
import TicketListPage from './pages/TicketListPage';
import ForgotPassword from './pages/ForgotPassword';
import PrivateRoute from './utils/PrivateRoute';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import Timesheet from './pages/Timesheet';
import EmployeeDetails from './pages/employee_details';
import HrmsDashboard from './pages/HrmsDashboard';
import Org from './pages/Org';
import FaceAttendance from './pages/face/FaceAttendance';
import GeoFencingPage from './pages/hrms/GeoFencingPage';
import EmailSettingsPage from './pages/EmailSettingsPage';
import DocumentationPage from './modules/documentation/DocumentationPage';
import ProjectManagementListPage from './pages/ProjectManagementListPage';
import AssessmentPage from './pages/assessment/AssessmentPage';
import TestExecutionPage from './pages/assessment/student/TestExecutionPage';
import MemberAssessmentDashboard from './pages/assessment/student/MemberAssessmentDashboard';
import { AssessmentProvider } from './pages/assessment/AssessmentContext';
import Layout from './components/Layout/Layout';
import { WorkflowWizard } from './pages/assessment/Wizard/BatchWizard';
import ServerDashboardPage from './pages/ServerDashboardPage';
import InfrastructureDashboardPage from './pages/InfrastructureDashboardPage';
import CollabMeetingDashboard from './components/Meeting/CollabMeetingDashboard';
import './styles/datepicker.css';
import InquiryDashboard from './modules/client_inquiry/InquiryDashboard';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />

      <Routes>
        {/* Show login page at root URL */}
        <Route path="/" element={<Login />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* HRMS Dashboard - Home */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <HrmsDashboard />
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/hrms"
          element={
            <PrivateRoute>
              <HrmsDashboard />
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/org"
          element={
            <PrivateRoute>
              <Org />
            </PrivateRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/tickets"
          element={
            <PrivateRoute>
              <TicketListPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/tickets/:ticketId"
          element={
            <PrivateRoute>
              <TicketListPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/server-dashboard"
          element={
            <PrivateRoute>
              <ServerDashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/infrastructure-dashboard"
          element={
            <PrivateRoute>
              <InfrastructureDashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/timesheet"
          element={
            <PrivateRoute>
              <Timesheet />
            </PrivateRoute>
          }
        />

        <Route
          path="/Dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee-details"
          element={
            <PrivateRoute>
              <EmployeeDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/face-attendance"
          element={
            <PrivateRoute>
              <FaceAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/geofencing"
          element={
            <PrivateRoute>
              <GeoFencingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/documentation"
          element={
            <PrivateRoute>
              <DocumentationPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-management"
          element={
            <PrivateRoute>
              <ProjectManagementListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-management/:taskId"
          element={
            <PrivateRoute>
              <ProjectManagementListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/email-settings"
          element={
            <PrivateRoute>
              <EmailSettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/client-inquiry"
          element={
            <PrivateRoute>
              <InquiryDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/assessment"
          element={
            <PrivateRoute>
              <AssessmentPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/workflow/:step"
          element={
            <PrivateRoute>
              <AssessmentProvider>
                <Layout noSidebar={true}>
                  <WorkflowWizard />
                </Layout>
              </AssessmentProvider>
            </PrivateRoute>
          }
        />

        <Route
          path="/assessment/live"
          element={
            <PrivateRoute>
              <MemberAssessmentDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/execution/:testId/:packId"
          element={
            <PrivateRoute>
              <TestExecutionPage />
            </PrivateRoute>
          }
        />
      
        {/* <Route
          path="/meetings"
          element={
            <PrivateRoute>
              <CollabMeetingDashboard />
            </PrivateRoute>
          }
        /> */}
      {/* <Route
        path="/meetings"
        element={
          <PrivateRoute>
            <CollabMeetingDashboard />
          </PrivateRoute>
        }
      /> */}

       <Route
          path="/meetings"
          element={<CollabMeetingDashboard />}
        />
      </Routes>
    </Router>
  );
}

export default App;